import { render, staticRenderFns } from "./locationSuppliersTable.vue?vue&type=template&id=252f85fe&"
import script from "./locationSuppliersTable.vue?vue&type=script&lang=js&"
export * from "./locationSuppliersTable.vue?vue&type=script&lang=js&"
import style0 from "./locationSuppliersTable.vue?vue&type=style&index=0&id=252f85fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports